import { render } from "./App.vue?vue&type=template&id=10059020"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=10059020&lang=scss"

import exportComponent from "D:\\兼职\\vue_jhdl\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__